import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {Observable} from 'rxjs';

import {IMyDateModel,IMyOptions} from 'mydatepicker';
import {BsModalRef,BsModalService} from 'ngx-bootstrap';
import {Principal} from 'src/app/core/auth/principal.service';
import {CountryMySuffixService} from 'src/app/entities/country-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {CargoCountryList, ISanctionedGroupMySuffix} from 'src/app/shared/model/sanctioned-group-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {SanctionedGroupMySuffixService} from './sanctioned-group-my-suffix.service';
import { ICargoGroupMySuffix } from 'src/app/shared/model/cargo-group-my-suffix.model';
import { CargoGroupMySuffixService } from '../cargo-group-my-suffix';
import { TreeviewConfig, TreeviewItem } from 'ngx-treeview';
import * as cloneDeep from 'lodash/cloneDeep';
import { CommonUtils } from 'src/app/shared/util/common-utils';
import { NgModel } from '@angular/forms';

declare let $: any;

@Component({
    selector: 'jhi-sanctioned-group-my-suffix-update',
    templateUrl: './sanctioned-group-my-suffix-update.component.html'
})
export class SanctionedGroupMySuffixUpdateComponent implements OnInit ,OnDestroy{
    private _sanctionedGroup: ISanctionedGroupMySuffix;
    isSaving: boolean;
    addWhiteListCargo: boolean = false;
    isDropDownDisabled: boolean = false;

    countries: ICountryMySuffix[];

    CountriesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen:false
    };

    // From effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }

    cargogroups: ICargoGroupMySuffix[];
    cargoLists: ICargoGroupMySuffix[]=[];
    selectedCountry: ICountryMySuffix[] = [];
    selectedCargoList: ICargoGroupMySuffix[] = [];
    cargogroupsDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };
    constructor(
        private jhiAlertService: JhiAlertService,
        private sanctionedGroupService: SanctionedGroupMySuffixService,
        private countryService: CountryMySuffixService,
        private activatedRoute: ActivatedRoute,
        private principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private languageChangeService:LanguageChangeService,
        private cargoGroupService: CargoGroupMySuffixService,

    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }
     
    // displayCargoes?:boolean=false;
    // countryId?: any;
    // isDropDownDisabled:boolean = false;

    isChecked: boolean = false;
    continentsRegionCountries: any[] = [];
    countriesId: any = [];
    selectedTreeviewContinent: any = [];
    countryData:TreeviewItem[] = [];
    countriesMap = new Map<number, any>();
    config = TreeviewConfig.create({
        hasAllCheckBox: true,
        hasFilter: true,
        hasCollapseExpand: true,
        decoupleChildFromParent: false,
        maxHeight: 400,
    });

    ngOnInit() {
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        this.isSaving = false;
        this.fromEffeciveDate = { date: this.dateModel };
        this.activatedRoute.data.subscribe(({ sanctionedGroup }) => {
            this.sanctionedGroup = sanctionedGroup;

            let url = sanctionedGroup.id!=null ? this.countryService.getCheckedCountriesByContinents(this.sanctionedGroup.countryLists.map(c=>c.id))
            : this.countryService.getCountriesWithContinentInTreeView(null);

            url.subscribe((res: any) => {
                this.countryData = this.mapToTreeViewItem(res.body!=null?res.body:res);
            });

        });
        // this.getAllCountry();
        this.getAllCargoes();
        this.addWhiteListCargo = this.activatedRoute.snapshot.queryParams["addWhiteListCargo"];
        if (this.addWhiteListCargo) {     
            this.activatedRoute.queryParams.subscribe(countryList => {  
                let country = countryList;
                this.selectedCountry = [countryList];

                if (this.sanctionedGroup.cargoCountryList.length > 0) {
                    let cargoCountry = this.sanctionedGroup.cargoCountryList.filter((cc: CargoCountryList) => {
                        return cc.country.id == countryList.id
                    })
                    if (cargoCountry == undefined || cargoCountry.length == 0 || cargoCountry.length > 1) {
                        this.selectedCargoList = [];
                    } else {
                        this.selectedCargoList = cargoCountry[0].cargoLists;
                    }
                }
                this.isDropDownDisabled = true;
            });
        }

        
    }

    previousState() {
        window.history.back();
    }

    save() {
      
        // From Effective Date
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.sanctionedGroup.fromEffectiveDate = incDate;
        this.sanctionedGroup.cargoLists = this.sanctionedGroup.cargoLists
        this.openConfirmationModalForFutureRecordDeletion();
    }

    saveOrUpdate() {
        if(this.countriesId.length > 0) {
            this.sanctionedGroup.countryLists = [];
            this.countriesId.filter(c=>this.countriesMap.has(c)).forEach(c=>{
                const coun:TreeviewItem=this.countriesMap.get(c);
                this.sanctionedGroup.countryLists.push({id:coun.value,name:coun.text});
            });
            // console.warn(this.sanctionedGroup.countryLists);
        } else {
            this.sanctionedGroup.countryLists = [];
        }

        this.isSaving = true;
            // if (this.sanctionedGroup.id !== undefined) {
            if (CommonUtils.isNotNil(this.sanctionedGroup.id)) {
                this.subscribeToSaveResponse(this.sanctionedGroupService.update(this.sanctionedGroup));
            } else {
                this.subscribeToSaveResponse(this.sanctionedGroupService.create(this.sanctionedGroup));
            }
        // }

    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<ISanctionedGroupMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<ISanctionedGroupMySuffix>) => this.onSaveSuccess(),
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
        if(this.sanctionedGroup && this.sanctionedGroup.id) {
            this.getViewData();
        }
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackCountryById(index: number, item: ICountryMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            // for (let i = 0; i < selectedVals.length; i++) {
            //     if (option.id === selectedVals[i].id) {
            //         return selectedVals[i];
            //     }
            // }
            for (let val of selectedVals) {
                if (option.id === val) {
                    return val;
                }
            }
        }
        return option;
    }
    get sanctionedGroup() {
        return this._sanctionedGroup;
    }

    set sanctionedGroup(sanctionedGroup: ISanctionedGroupMySuffix) {
        this._sanctionedGroup = sanctionedGroup;
    }

    trimName(event) {
        if (this.sanctionedGroup.name) {
            this.sanctionedGroup.name = this.sanctionedGroup.name.trim();
        }
        // $(document).find('.surveyCompanyPortClass .dropdown-list').addClass('showDropdown');
        // $(document).find('.surveyCompanyPortClass .dropdown-list').removeClass('showDropdown');
    }
    onSelectSanctionList() {
        $(document).find('.sanctionListClass .dropdown-list').addClass('showDropdown');
    }

    onDropdownSanctionListClose() {
        $(document).find('.sanctionListClass .dropdown-list').removeClass('showDropdown');
    }
    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        console.log('onDateChanged(): ', selectedFromEffectiveDate);
        // if (this.sanctionedGroup.id !== null && this.sanctionedGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.sanctionedGroup.id)) {
            //let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
            // console.log('onDateChanged(): ', selectedFromEffectiveDate);
            this.sanctionedGroupService.findByIdAndFromEffectiveDate(this.sanctionedGroup.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']) {
                    this.sanctionedGroup = response.body['payLoad'];
                }
            });
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.sanctionedGroup.id !== null && this.sanctionedGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.sanctionedGroup.id)) {
            let form_data = {
                masterId: this.sanctionedGroup.id,
                futureDataType: FutureDataType.SANCTIONED_GROUP.valueOf(),
                fromEffectiveDateFormatted: this.sanctionedGroup.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Sanctioned Group (' + this.sanctionedGroup.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.sanctionedGroup.id,
                futureDataType: FutureDataType.SANCTIONED_GROUP.valueOf(),
                fromEffectiveDateFormatted: this.sanctionedGroup.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }

    onSelectCargos() {
        // $(document).find('.cargoClass .dropdown-list').addClass('showDropdown');
    }

    onDropdownCargoClose() {
        $(document)
            .find('.cargoClass .dropdown-list')
            .removeClass('showDropdown');
    }

    getAllCountry() {
        this.countryService
            .query({
                page: 0,
                size: 300
                // sort: null
            })
            .subscribe(
                (res: HttpResponse<ICountryMySuffix[]>) => {
                    this.countries = res.body;
                },
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    getAllCargoes() {
        this.cargoGroupService.queryAll().subscribe(
            (res: HttpResponse<ICargoGroupMySuffix[]>) => {
                this.cargogroups = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );

    }

    onDeSelectCargos(event) {
        this.sanctionedGroup.cargoLists.splice(event, 1);
    }
    onSelectAllCargos(event) {
        this.cargogroups.forEach(data => {
            this.sanctionedGroup.cargoLists.push(data);
        })
    }
    onDeSelectAllCargos(event) {
        this.sanctionedGroup.cargoLists = [];
    }

    onSubmit() {
        // if (this.selectedCargoList == undefined || this.selectedCargoList == null || this.selectedCountry == undefined || this.selectedCountry == null) {
        if (CommonUtils.isNil(this.selectedCargoList) || CommonUtils.isNil(this.selectedCountry)) {
            this.sanctionedGroup.cargoCountryList = [];
        }

        // always send the record which is going to be updated
        this.sanctionedGroup.cargoCountryList = [new CargoCountryList(null, this.selectedCountry[0], this.selectedCargoList)];

        this.isSaving = true;
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.sanctionedGroup.fromEffectiveDate = incDate;
        // if (this.sanctionedGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.sanctionedGroup.id)) {
            this.subscribeToSaveResponse(this.sanctionedGroupService.cargoUpdate(this.sanctionedGroup));
        }
    }
    getViewData() {
        this.sanctionedGroupService.view(this.sanctionedGroup.id).subscribe(res => {
            this.sanctionedGroup = res.body;
        })
    }
    ngOnDestroy(): void {
        this.addWhiteListCargo = false;
    }

    selectedCountries(event){
        this.selectedTreeviewContinent = event;
        this.countriesId = event;
    }

    mapToTreeViewItem(data){
        for(let i = 0;i<data.length;i++){
            data[i] = new TreeviewItem(data[i],true); // continent
            if(data[i].children && data[i].children.length>0){
                for(let j = 0;j<data[i].children.length;j++){
                    data[i].children[j]= new TreeviewItem(data[i].children[j],true); // region
                    if(data[i].children[j] && data[i].children[j].children.length>0){
                        for(let k = 0;k<data[i].children[j].children.length;k++){
                            data[i].children[j].children[k]= new TreeviewItem(data[i].children[j].children[k]); // country
                            this.countriesMap.set(data[i].children[j].children[k].value,data[i].children[j].children[k]);
                        }
                    }
                }
            }
        }
        // console.warn(this.countriesMap);
        // console.warn(data);
        return data;
      }

      onFilterKeyup(e: KeyboardEvent, countryList: NgModel) {
        const filterValue = (e.target as HTMLInputElement).value;
        if(filterValue.length === 0) {
            countryList.control.setErrors(null);
        }
      }
      
}
